import Vue from 'vue';
import toast from "@/components/common/bdToast/toast";

let toastInstance = null;
function clear(){
	if(toastInstance && document.body.contains(toastInstance.$el)) {
		toastInstance.$el.remove();
		toastInstance.$destroy();
		toastInstance = null;
	}
}
function createToastIns (msg, duration = 1200){
	clear();
	toastInstance = new (Vue.extend(toast))({
		el : document.createElement('div'),
	});
	toastInstance.msg = msg;
	document.body.appendChild(toastInstance.$el);
	setTimeout(() => {
		clear();
	}, duration);
}

export default createToastIns;



// WEBPACK FOOTER //
// ./src/components/common/bdToast/index.js